export default {
    title: 'Massenbearbeitung',

    maxProcessesForMassApproval: 'Es werden nur die ersten 1000 Maßnahmen berücksichtigt.',
    massApprovalNotAvailableForProcesses: 'Für die folgenden Maßnahmen ist die Massenbearbeitung nicht verfügbar, da der Status der Maßnahme nicht in den Status, der genehmigte oder abgelehnte Maßnahmen markiert, überführt werden kann:\n{processes}.\n\nErlaubte Status: {allowedStatuses}.',

    startMassApproval: 'Massenbearbeitung starten',
    errorOnStartingMassApproval: 'Fehler beim Starten der Massenbearbeitung',
}